export default __webpack_public_path__ + "guide--imagery-4up-480-62f61452e33de7117916bb4b99da9641.png";